import React from 'react';
import { Box, Typography, Container, Grid, Card, CardMedia } from '@mui/material';
import carCompleteScan from '../images/services/car-complete-scan.jpg';
import oilService from '../images/services/oil-service.jpg';
import wheelAlignment from '../images/services/wheel-alignment.jpg';
import wheelBalancing from '../images/services/wheel-balancing.jpg';
import tyreChanging from '../images/services/tyre-changing.jpg';
import insuranceRenewal from '../images/services/insurance-renewal.jpg';
import tinkeringPainting from '../images/services/tinkering-painting.jpg';
import minorMajorRepairs from '../images/services/minor-major-repairs.jpg';
import interiorCleaning from '../images/services/interior-cleaning.jpg';
import vacuumCleaning from '../images/services/vacuum-cleaning.jpg';
import waterWashing from '../images/services/water-washing.jpg';
import rubbingPolishing from '../images/services/rubbing-polishing.jpg';
import breakdownService from '../images/services/breakdown-service.jpg';

const Services = () => {
  const services = [
    { title: 'Car Complete Scan', image: carCompleteScan },
    { title: 'Oil Service', image: oilService },
    { title: 'Wheel Alignment', image: wheelAlignment },
    { title: 'Wheel Balancing', image: wheelBalancing },
    { title: 'Tyre Changing', image: tyreChanging },
    { title: 'Insurance Renewal', image: insuranceRenewal },
    { title: 'Tinkering & Painting', image: tinkeringPainting },
    { title: 'Minor & Major Repairs', image: minorMajorRepairs },
    { title: 'Interior Cleaning', image: interiorCleaning },
    { title: 'Vacuum Cleaning', image: vacuumCleaning },
    { title: 'Water Washing', image: waterWashing },
    { title: 'Rubbing Polishing', image: rubbingPolishing },
    { title: '24X7 Break Down Service', image: breakdownService },
  ];

  return (
    <Box
      id="about_us"
      sx={{
        backgroundColor: '#ffffff',
        padding: { xs: '60px 20px', sm: '80px 40px', md: '100px 80px' },
        position: 'relative',
        boxShadow: 'inset 0 1px 0 0 rgba(0,0,0,0.04)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'radial-gradient(circle at 80% 20%, rgba(255, 111, 0, 0.03) 0%, transparent 50%)',
          pointerEvents: 'none'
        }
      }}
    >
      <Container maxWidth="xl" sx={{ width: '100%', position: 'relative', zIndex: 1 }}>
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="flex-start">
          <Grid item xs={12}>
            <Grid container spacing={{ xs: 2, sm: 3 }}>
              {services.map((service, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    sx={{
                      height: '100%',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      backgroundColor: 'white',
                      position: 'relative',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(135deg, rgba(26, 35, 126, 0.8) 0%, rgba(255, 111, 0, 0.8) 100%)',
                        opacity: 0,
                        transition: 'opacity 0.4s ease',
                        zIndex: 1
                      },
                      '&:hover': {
                        transform: 'translateY(-10px) scale(1.02)',
                        boxShadow: '0 16px 32px rgba(0,0,0,0.2)',
                        '&::after': {
                          opacity: 1
                        },
                        '& .service-image': {
                          transform: 'scale(1.1)'
                        },
                        '& .service-title': {
                          color: 'white',
                          zIndex: 2,
                          position: 'relative'
                        }
                      }
                    }}
                  >
                    <Box sx={{ position: 'relative', overflow: 'hidden', height: '200px' }}>
                      <CardMedia
                        component="img"
                        height="200"
                        image={service.image}
                        alt={service.title}
                        className="service-image"
                        sx={{ 
                          objectFit: 'cover',
                          objectPosition: 'center',
                          width: '100%',
                          height: '100%',
                          transition: 'transform 0.4s ease'
                        }}
                      />
                    </Box>
                    <Box sx={{ 
                      padding: { xs: '20px', md: '24px' }, 
                      textAlign: 'center',
                      flexGrow: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      zIndex: 2
                    }}>
                      <Typography
                        variant="h6"
                        className="service-title"
                        sx={{
                          fontWeight: 'bold',
                          color: '#1a237e',
                          fontSize: { xs: '15px', md: '17px' },
                          lineHeight: 1.3,
                          transition: 'color 0.4s ease'
                        }}
                      >
                        {service.title}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
          {/* <Grid item xs={12} md={4}>
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: { xs: 'flex-start', md: 'center' },
                paddingLeft: { xs: 0, md: '40px', lg: '60px' },
                marginTop: { xs: '40px', md: 0 },
                maxWidth: { xs: '100%', md: '400px' }
              }}
            >
              <Typography
                sx={{
                  color: '#ff6f00',
                  fontSize: { xs: '12px', md: '14px' },
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  letterSpacing: '2px',
                  marginBottom: '16px',
                  display: 'block'
                }}
              >
                PROJECTS
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '28px', sm: '32px', md: '42px', lg: '48px' },
                  fontWeight: 'bold',
                  color: '#1a237e',
                  marginBottom: { xs: '28px', md: '32px' },
                  lineHeight: 1.2
                }}
              >
                Selected Works
                <br />
                from Us
              </Typography>
              <Box
                component="button"
                sx={{
                  background: 'linear-gradient(135deg, #ffb3ba 0%, #ff9ca3 100%)',
                  color: '#1a237e',
                  border: 'none',
                  borderRadius: '8px',
                  padding: { xs: '12px 32px', md: '14px 36px' },
                  fontSize: { xs: '14px', md: '16px' },
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  textTransform: 'none',
                  width: 'fit-content',
                  boxShadow: '0 4px 12px rgba(255, 179, 186, 0.3)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '-100%',
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                    transition: 'left 0.5s'
                  },
                  '&:hover': {
                    background: 'linear-gradient(135deg, #ff9ca3 0%, #ffb3ba 100%)',
                    boxShadow: '0 6px 20px rgba(255, 179, 186, 0.4)',
                    transform: 'translateY(-2px)',
                    '&::before': {
                      left: '100%'
                    }
                  },
                  '&:active': {
                    transform: 'translateY(0px)'
                  }
                }}
              >
                See More
              </Box>
            </Box>
          </Grid> */}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
